<template>
  <a @click="editUser"
     class="button is-primary is-medium is-fullwidth">
    <span class="icon">
      <i class="fa fa-plus"></i>
    </span>
    <span>Criar</span>
  </a>
</template>

<script>
  import Vue from 'vue'
  import EditUserCardModal from './UserEditModal'

  const CardEditModalComponent = Vue.extend(EditUserCardModal)

  export default {
    components: {
      EditUserCardModal
    },
    data () {
      return {
      }
    },

    methods: {

      editUser () {
        let openCardModal = (propsData = {}) => {
          return new CardEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Novo Utilizador'
        })
      }
    }
  }
</script>

<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// UserNew.vue?e4ec756e